import type { InputHTMLAttributes } from 'react';
import { cx } from '../lib/cx';
import { Field, borderClass, controlClass } from './Field';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  id: string;
  label?: string;
  hint?: string;
  error?: string | undefined;
}

export function Input({ id, label, hint, error, className, required, ...rest }: InputProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error} required={required}>
      <input
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
        required={required}
        className={cx(controlClass, borderClass(!!error), className)}
        {...rest}
      />
    </Field>
  );
}
